import React from 'react';
import ScrollEffectWrapper from './ScrollEffectWrapper';
import ProjectCard from './ProjectCard';
import notableProjects from '../data/notableProjects';

function NotableProjectsSection() {
  return (
    <section className="section projects-section">
      <div className="container">
        <ScrollEffectWrapper animationType="title">
          <div className="section-header">
            <h2 className="section-title">Notable Projects</h2>
            <p className="section-subtitle">Additional projects showcasing my skills</p>
          </div>
        </ScrollEffectWrapper>

        <div className="projects-grid">
          {notableProjects.map((project, index) => (
            <ScrollEffectWrapper key={project.title} animationType="slide-up" delay={index * 100}>
              <ProjectCard project={project} />
            </ScrollEffectWrapper>
          ))}
        </div>
      </div>
    </section>
  );
}

export default NotableProjectsSection;
